const objectSchemeCheck = (obj: any, keys: any) => {
    const objKeys = Object.keys(obj);

    const len = objKeys.length;
    for (let i = 0; i < len; i++) {
        if (!keys.includes(objKeys[i])) {
            return false;
        }
    }
    return true;
};

export default objectSchemeCheck;
